import React from "react";
import PropTypes from 'prop-types';
import "./filesSkeleton.scss";
function URFilesSkeleton(props: any) {
  let {className } = props;
  return (
    <>
      <div className={className}><span className="statusDot"></span></div>
    </>

  );
}

export {
  URFilesSkeleton
};

URFilesSkeleton.propTypes = {
  className: PropTypes.any
};